module.exports = __webpack_public_path__ + "static/media/wrong-quiz-icon.b0850b1b.svg";